import { useEffect, useState } from "react";
import { InviteModal, InviteModalProps } from "./InviteModal";
import { ButtonAnalyticsProvider, useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

/**
 * Invite external user closeable modal for media-page in share modal
 */
export const InviteShareItem = (props: InviteModalProps) => {
    const { autoFocus, onCloseMenu, onClose, ...modalProps } = props;

    const [isOpen, setIsOpen] = useState(true);
    const sendButtonAnalytics = useButtonAnalytics();

    useEffect(() => {
        sendButtonAnalytics(
            "Invite user - open modal",
            ButtonClickAnalyticsType.OPEN,
            props.entryId,
            "invitetomedia",
            "Entry page / media owner view"
        );
    }, []);

    const closeModal = () => {
        setIsOpen(false);
        onClose?.();
    };

    return (
        <ButtonAnalyticsProvider applicationFeature={"invitetomedia"} location={"Invitation modal"}>
            {isOpen && <InviteModal {...modalProps} onClose={closeModal} />}
        </ButtonAnalyticsProvider>
    );
};
